import script from "./WellPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./WellPanel.vue?vue&type=script&setup=true&lang=ts"

import "./WellPanel.vue?vue&type=style&index=0&id=6523c8d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6523c8d0"]])

export default __exports__